import DashboardLayout from "../../components/DashboardLayout";
import ChatSupport from "../../components/pages/Messages/ChatSupport";
import { MessageProvider } from "../../context/messageContext";

const Messages = () => {
  return (
    <MessageProvider>
      <DashboardLayout
        title="Messages"
        description="Converse easily with your team with ease. "
        containerClass="space-y-10"
      >
        <ChatSupport />
      </DashboardLayout>
    </MessageProvider>
  );
};
export default Messages;
